module.exports = __webpack_public_path__ + "static/media/icon-pentagon-white.8256d06d.svg";